import { z } from 'zod/v4';
import { TarotCardSchema, ElementSchema, SephirahNameSchema, SuitSchema } from './tarot.schema.js';
export const MemoryEntityKindSchema = z.enum([
    'dominant_card',
    'dominant_suit',
    'dominant_element',
    'dominant_sephirah',
    'recurring_theme',
    'recurring_pair',
    'archetype',
    'qliphotic_pattern',
    'decanal_affinity',
    'angelic_resonance',
]);
export const MemoryEntitySchema = z.object({
    id: z.string().min(1),
    user_id: z.string().min(1),
    kind: MemoryEntityKindSchema,
    label: z.string().min(1),
    strength: z.number(),
    sigma: z.number(),
    first_seen: z.string().min(1),
    last_seen: z.string().min(1),
    occurrences: z.number().int().nonnegative(),
    metadata: z.record(z.string(), z.unknown()),
});
export const BirkhoffReportSchema = z.object({
    card: TarotCardSchema,
    expected_frequency: z.number().nonnegative(),
    observed_frequency: z.number().nonnegative(),
    sigma: z.number(),
    interpretation: z.string().min(1),
});
export const DominantSuitSchema = z.object({
    suit: SuitSchema,
    percentage: z.number().min(0).max(100),
});
export const DominantElementSchema = z.object({
    element: ElementSchema,
    percentage: z.number().min(0).max(100),
});
export const DominantSephirahSchema = z.object({
    sephirah: SephirahNameSchema,
    percentage: z.number().min(0).max(100),
});
export const RecurringPairSchema = z.object({
    cards: z.tuple([z.string().min(1), z.string().min(1)]),
    occurrences: z.number().int().nonnegative(),
});
export const ThemeStrengthSchema = z.object({
    theme: z.string().min(1),
    strength: z.number(),
});
export const TemporalAffinitySchema = z.object({
    decan_range: z.string().min(1),
    affinity: z.number(),
});
export const MemoryModalityBalanceSchema = z.object({
    Cardinale: z.number(),
    Fisso: z.number(),
    Mutabile: z.number(),
});
export const UserMemorySummarySchema = z.object({
    total_readings: z.number().int().nonnegative(),
    shannon_entropy: z.number().nonnegative(),
    entropy_interpretation: z.string().min(1),
    dominant_cards: z.array(BirkhoffReportSchema),
    dominant_suits: z.array(DominantSuitSchema),
    dominant_elements: z.array(DominantElementSchema),
    dominant_sephiroth: z.array(DominantSephirahSchema),
    recurring_pairs: z.array(RecurringPairSchema),
    modality_balance: MemoryModalityBalanceSchema,
    themes: z.array(ThemeStrengthSchema),
    temporal_affinities: z.array(TemporalAffinitySchema),
});
export const MemoryEntityJsonSchema = z.toJSONSchema(MemoryEntitySchema);
//# sourceMappingURL=memory.schema.js.map